import { atom } from 'recoil';

export const CalculatorStepState = atom<'welcome' | 'ambarcatiune' | 'skijet' | 'peridoc' | 'datele-tale' | 'checkout'>({
  key: 'CalculatorStep',
  default: 'welcome',
});

export const WelcomeOptionState = atom<{ denumirePachet: string, indxPachet: number } | undefined>({
  key: 'WelcomeOptionState',
  default: void 0,
});

export const CalculatorAmbarcatiuneState = atom<{
  unitate: 'ft' | 'm',
  lungime?: number,
}>({
  key: 'CalculatorAmbarcatiuneState',
  default: {
    unitate: 'm',
  },
});